import React, { Component } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./css/style.scss";

export default class SlickSlider extends Component {
    constructor(props) {
        super(props);
  
        this.state = {
          img: [],
          currentIndex: 0,
          translateValue: 0,
          galleryName: []
        }
      }
  
    componentDidMount() {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var galleryId = url.searchParams.get("galleryId");


    var headers = new Headers();
    var username = 'staging';
    var password = 'wearenois3';
    headers.append('Authorization', 'Basic ' + btoa(username + ':' + password));
    headers.append('Content-Type', 'image/jpeg');
    //fetch('https://host.com', {headers: headers})
console.log(headers);
    fetch(process.env.REACT_APP_API_URL+'api/singleGallery/'+galleryId, {headers: headers})
    .then(res => res.json())
    .then((res) => {
        this.setState({ img: res.single })
        this.setState({ galleryName: res.name })
        console.log(this.state.galleryName)
    })
    .catch(function(error) {
        console.log(error);
    })
    }
  
    render() {
        const settings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,          
        };
        return (
          <div>
            <h3 className="typo-span">{this.state.galleryName.toString().split("/")[1]} </h3>
            <Slider {...settings} >
            {
                this.state.img.map((image, i) => (
                    <div  key={i} >
                        <img src={process.env.REACT_APP_API_URL+image.path} />
                        <div className="slick__caption">
                            <div className="slick_text">
                                {image.name.toString().split("-")[1]} <a className='nomargin' href={process.env.REACT_APP_API_URL+image.path} target='_blank'>scarica foto</a>
                            </div>
                        </div>
                    </div>  
                ))
            }
            </Slider>
          </div>
        );
    } 
}